module.exports = __webpack_public_path__ + "media/components/components/booking/KidsSafety/assets/seatbelts-83686e4ab524b22a049c30316c82031f.svg";